import React, { useState, useLayoutEffect, useCallback, useRef } from "react";
import { PLAN_GRID_VIEWS } from "components/Plans";
import PlanTableHead from "components/Plans/PlanTableHead";
import PlanTableBody from "components/Plans/PlanTableBody";
import PlanTableHeadInverted from "components/Plans/PlanTableHeadInverted";
import PlanTableBodyInverted from "components/Plans/PlanTableBodyInverted";
import i18next from "i18next";

const PlanTable = (props) => {
	const [resizePreview, setResizePreview] = useState(null);
	const resizePreviewRafRef = useRef(null);
	const pendingResizePreviewRef = useRef(null);

	useLayoutEffect(() => {
		// Tras materializar horas / refresh: soltar overlays post-commit.
		// No tocar un drag activo (sin pendingCommit/sticky).
		setResizePreview((prev) => {
			if (!prev) return prev;
			if (prev.pendingCommit || prev.sticky) return null;
			return prev;
		});
	}, [props.plan_assignments]);

	const handleResizePreviewChange = useCallback((next) => {
		if (next == null || next?.pendingCommit) {
			if (resizePreviewRafRef.current != null) {
				cancelAnimationFrame(resizePreviewRafRef.current);
				resizePreviewRafRef.current = null;
			}
			pendingResizePreviewRef.current = null;
			setResizePreview(next);
			return;
		}

		pendingResizePreviewRef.current = next;
		if (resizePreviewRafRef.current == null) {
			resizePreviewRafRef.current = requestAnimationFrame(() => {
				resizePreviewRafRef.current = null;
				setResizePreview(pendingResizePreviewRef.current);
				pendingResizePreviewRef.current = null;
			});
		}
	}, []);

	const tableProps = {
		...props,
		resizePreview,
		setResizePreview: handleResizePreviewChange,
	};

	var tableClass = "";
	if (props.plan_grid_view === PLAN_GRID_VIEWS.ubications) {
		tableClass = "table-ubications";
	} else if (props.plan_grid_view === PLAN_GRID_VIEWS.ubication_grouped) {
		tableClass = "table-ubication-grouped";
	} else if (props.plan_grid_view === PLAN_GRID_VIEWS.shifts) {
		tableClass = "table-default table-shifts-grouped";
	} else if (props.plan_grid_view === PLAN_GRID_VIEWS.default) {
		tableClass = "table-default";
	} else if (props.plan_grid_view === PLAN_GRID_VIEWS.grid) {
		tableClass = "table-grid";
	}

	if (props.plan_assignments.length === 0) return "";

	if (props.plan_grid_view === PLAN_GRID_VIEWS.vertical) {
		return (
			<table
				id="tablePlan"
				className={`table table-bordered table-plan table-plan-main table-plan-vertical`}
			>
				<PlanTableHeadInverted {...tableProps} />
				<PlanTableBodyInverted {...tableProps} />
			</table>
		);
	}

	return (
		<table
			id="tablePlan"
			className={`table table-bordered table-plan table-plan-main ${tableClass}`}
		>
			<PlanTableHead {...tableProps} />
			<PlanTableBody {...tableProps} />
			{props.multigroupSections?.length > 0 &&
				props.plan_grid_view === PLAN_GRID_VIEWS.default && (
					<tfoot>
						<tr className="multigroup-grand-total">
							<th className="main-col">
								<div className="th-wrap">
									{i18next.t("plan.multigroup.grandTotal")}
								</div>
							</th>
							{(props.plan_days || []).length > 0 && (
								<td
									colSpan={(props.plan_days || []).length}
									className="shift-cell multigroup-section-fill"
								/>
							)}
						</tr>
					</tfoot>
				)}
		</table>
	);
};

export default PlanTable;
